import { Link } from 'react-router-dom';

export default function AboutArticleSection() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-12 lg:gap-20">
        <div className="w-full lg:w-[42%] flex flex-col justify-center">
          <span className="inline-block px-3 py-1 border border-secondary-300 rounded-full text-secondary-700 text-xs font-label tracking-wider mb-5 self-start">
            SEO Guide
          </span>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 mb-2 leading-tight">
            YOYBUY Sheet
          </h2>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-heading font-light text-secondary-500 italic mb-8">
            Полное Руководство 2026
          </h3>

          <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8">
            YOYBUY Spreadsheet — это мощный инструмент для организации заказов из Китая. В этом полном руководстве 2026 года вы узнаете, как использовать таблицу YOYBUY для экономии до 30% на покупках, сравните её с Kakobuy и Superbuy, и получите пошаговый туториал для начинающих.
          </p>

          <Link
            to="/yoybuy-sheet-guide-2026"
            className="inline-flex items-center gap-2 text-base font-semibold text-foreground-900 border-b-2 border-foreground-900 pb-1 hover:text-primary-500 hover:border-primary-500 transition-colors whitespace-nowrap"
          >
            Читать SEO-статью полностью
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="w-full lg:w-[58%]">
          <div className="flex items-end justify-end gap-4 mb-4">
            <div className="text-right">
              <div className="text-4xl md:text-5xl font-heading font-bold text-foreground-900">10 000+</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">SKU в таблице</div>
            </div>
            <div className="w-px h-12 bg-background-200"></div>
            <div className="text-right">
              <div className="text-4xl md:text-5xl font-heading font-bold text-foreground-900">99%</div>
              <div className="text-xs md:text-sm text-foreground-500 mt-1">Экономии времени</div>
            </div>
          </div>

          <div className="flex gap-3 md:gap-4 items-start">
            <div className="w-[45%] aspect-square rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20spreadsheet%20interface%20on%20macbook%20screen%20showing%20product%20catalog%20with%20organized%20columns%20soft%20warm%20lighting%20modern%20workspace%20aesthetic%20cream%20background%20professional%20SaaS%20style%20editorial%20photography%20no%20text%20visible&width=500&height=500&seq=yoybuy-about-sq-03&orientation=squarish"
                alt="YOYBUY Spreadsheet интерфейс"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-[55%] aspect-[3/4] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Beautiful%20product%20collection%20display%20with%20designer%20baby%20clothes%20mini%20sneakers%20tiny%20hoodies%20cute%20accessories%20and%20small%20perfume%20bottles%20arranged%20on%20light%20cream%20surface%20warm%20natural%20light%20soft%20shadows%20editorial%20style%20European%20baby%20fashion%20aesthetic%20high%20key%20photography%20airy%20clean%20composition&width=600&height=800&seq=yoybuy-about-portrait-04&orientation=portrait"
                alt="Коллекция товаров YOYBUY"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}